module.exports = __webpack_public_path__ + "media/src/assets/images/about_solution-pic1-e827a26ab29c5143ddf16757dc18d0df.png";